<div class="lightshow-timeline">
  <div
    [isDisabled]="disableHoverTips"
    tooltip="Torch Segment List. Contains all of the torch segments that compose your light show. You can select a segment and edit the start time and duration, or delete the segment. Selecting multiple torches using Ctrl + Left Mouse allows you to change the type of, or delete, multiple segments at once"
    #timeline
    class="timeline"
    [ngStyle]="{
      'overflow-x': lightshowOperations.length > 6 ? 'scroll' : 'hidden'
    }"
  >
    <div
       #segments
      *ngFor="let operation of lightshowOperations; let i = index"
      class="item center-items"
      [ngClass]="{
        'selected-segment': checkIfOperationIsSelected(operation.uniqueId),
        'opacity-1': !checkIfOperationIsSelected(operation.uniqueId)
      }"
      (click)="shouldFreeze ? '' : selectOperation(operation.uniqueId)"
      (mouseenter)="operation.hover = true"
      (mouseleave)="operation.hover = false"
      [style.border]="!operation.show ? '3px solid orange' : checkIfOperationIsSelected(operation.uniqueId) ? '1.5px solid black' : 'none'"
    >
      <div class="delete-btn center-items" (click)="deleteOperation(i)"><span>+</span></div>
      <div *ngIf="lightshowOperations[i].hover" (click)="hideOperation(i)">
        <img
          *ngIf="lightshowOperations[i].show"
          class="hide-btn"
          style="z-index: 1;"
          src="../../../assets/app/media/img/icons/eye.png">
        <img
          *ngIf="!lightshowOperations[i].show"
          class="hide-btn"
          style="z-index: 1;"
          src="../../../assets/app/media/img/icons/eye_x.png">
      </div>
      <div class="torch-item center-items">
        <svg
          *ngIf="operation.flashType === 0"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 1000 1000"
          enable-background="new 0 0 1000 1000"
          xml:space="preserve"
          width="20"
          fill="white"
          [style.filter]="operation.hover ? 'brightness(50%)' : none"
        >
          <metadata>
            Svg Vector Icons : http://www.onlinewebfonts.com/icon
          </metadata>
          <g>
            <path
              d="M886.4,115.5c44.9,44.9,75.7,92,92.4,141.3c16.7,49.3,14.9,82.6-5.4,100L827.7,502.3c-11.6,11.6-34,21-67.4,28.3s-68.1,8.7-104.3,4.3L212.6,978.3c-13,13-33.7,15.2-61.9,6.5S95.3,958,69.2,930.5c-26.1-26.1-43.8-52.9-53.2-80.4c-9.4-27.5-7.6-47.8,5.4-60.9l443.4-443.4c-4.3-36.2-2.9-71,4.3-104.3c7.2-33.3,16.7-55.8,28.3-67.4L645.1,26.4c17.4-20.3,50.7-21.7,100-4.3C794.4,39.4,841.4,70.5,886.4,115.5L886.4,115.5 M399.5,558.8c23.2,23.2,52.2,18.1,86.9-15.2c33.3-33.3,38.4-63,15.2-89.1c-10.1-10.1-23.9-13.8-41.3-10.9c-17.4,2.9-33.3,11.6-47.8,26.1c-14.5,14.5-22.8,30.1-25,46.7C385.4,533.1,389.4,547.2,399.5,558.8L399.5,558.8 M764.7,235c21.7,21.7,46.4,39.8,73.9,54.3c27.5,14.5,50,23.5,67.4,27.2s27.5,4,30.4,1.1c1.4-2.9,0-12.7-4.3-29.3s-13.8-38.4-28.3-65.2c-14.5-26.8-32.6-51.1-54.3-72.8c-21.7-21.7-45.6-39.8-71.7-54.3c-26.1-14.5-47.5-23.9-64.1-28.3c-16.7-4.3-26.4-5.1-29.3-2.2c-2.9,2.9-2.5,13,1.1,30.4c3.6,17.4,12.7,39.8,27.2,67.4S744.4,214.7,764.7,235L764.7,235"
            />
          </g>
        </svg>
        <img
          [style.filter]="operation.hover ? 'brightness(50%)' : none"
          width="40"
          *ngIf="operation.flashType === 1"
          src="../../../assets/app/media/img/icons/strobe3x.png"
        />
        <img
          [style.filter]="operation.hover ? 'brightness(50%)' : none"
          width="30"
          *ngIf="operation.flashType === 59"
          src="../../../assets/app/media/img/icons/sparke3x.png"
        />
      </div>
    </div>
  </div>

  <div class="edit">
    <div
      class="time-control justify-content-evenly"
    >
    <div>
      <label> Type </label>
      <ng-select
        [isDisabled]="disableHoverTips"
        tooltip='Torch Flash Types. Choose your flash type. "Solid" keeps the torch on for the total duration of the segment. "Strobe" quickly blinks the torch. "Sparkle" randomly ramps the torch on and off on iOS only' 
        [disabled]="shouldFreeze"
        class="ng-select-lightshow-theme"
        [searchable]="false"
        [clearable]="false"
        [items]="flashTypes"
        [(ngModel)]="selectedOperationType"
        (change)="changeSelectedOperationsType($event)"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="torch-icon-container">
            <img
              width="20"
              *ngIf="item === 'SOLID'"
              src="../../../assets/app/media/img/icons/torch3x.png"
              style="filter: invert(100%)"
            />

            <img
              width="20"
              *ngIf="item === 'STROBE'"
              src="../../../assets/app/media/img/icons/strobe3x.png"
              style="filter: invert(100%)"
            />

            <img
              width="20"
              *ngIf="item === 'SPARKLE'"
              src="../../../assets/app/media/img/icons/sparke3x.png"
              style="filter: invert(100%)"
            />
            {{ item }}
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div class="torch-icon-container">
            <img
              width="20"
              *ngIf="item === 'SOLID'"
              src="../../../assets/app/media/img/icons/torch3x.png"
              style="filter: invert(100%)"
            />

            <img
              width="20"
              *ngIf="item === 'STROBE'"
              src="../../../assets/app/media/img/icons/strobe3x.png"
              style="filter: invert(100%)"
            />

            <img
              width="20"
              *ngIf="item === 'SPARKLE'"
              src="../../../assets/app/media/img/icons/sparke3x.png"
              style="filter: invert(100%)"
            />

            <img
              width="20"
              *ngIf="item === 'SEQUENCE'"
              src="../../../assets/app/media/img/icons/sparke3x.png"
              style="filter: invert(100%)"
            />
            {{ item }}
          </div>
        </ng-template>
      </ng-select>
    </div>
      <div 
      [isDisabled]="disableHoverTips"
      tooltip="Start time of the selected torch segment in seconds"
      >
        <label for="start"> Start </label>
        <input
          *ngIf="getSelectedOperationsLength() === 1"
          #start
          id="start"
          class="form-control"
          type="number"
          step="0.1"
          [value]="selectedOperation ? (selectedOperation.position / 1000 | number: '1.2-2') : 0"
          (keypress)="preventAutoPlay($event)"
          (keyup.enter)="
            setSelectedOperationPosition($event.target.value * 1000)
          "
          (change)="setSelectedOperationPosition($event.target.value * 1000)"
          (focus)="startFocus = true"
          (blur)="startFocus = false"
        />
      </div>
      <div
      [isDisabled]="disableHoverTips"
      tooltip="Total duration of the selected torch segment in seconds"
      >
        <label for="duration"> Duration </label>
        <input
          *ngIf="getSelectedOperationsLength() === 1"
          #duration        
          id="duration"
          class="form-control"
          type="number"
          step="0.1"
          [value]="
          selectedOperation ? (selectedOperation.duration / 1000
              | number: '1.2-2') : 0
          "
          (keypress)="preventAutoPlay($event)"
          (keyup.enter)="
            setSelectedOperationDuration($event.target.value * 1000)
          "
          (change)="setSelectedOperationDuration($event.target.value * 1000)"
          (focus)="durationFocus = true"
          (blur)="durationFocus = false"
        />
      </div> 
      <div
      [isDisabled]="disableHoverTips"
      tooltip="Clicking here will deselect all selected torch segments"
      >
        <button 
          [disabled]="getSelectedOperationsLength() < 1" 
          [ngClass]="{'deselect-button': getSelectedOperationsLength() > 0, 'deselect-button-disabled': getSelectedOperationsLength() < 1}" 
          (click)="deselectOperations()" class="deselect-button button">
            DESELECT
        </button>
      </div> 
    </div>
  </div>
</div>
